export const MANAGER = 'manager';
export const ADMIN = 'admin';
export const STAFF = 'staff';
export const TRAINEE = 'trainee';
export const INTERVIEWEE = 'interviewee';
export const ENGINEER = 'engineer';


// TODO: DRY the following methods
const _isManager = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && (userRoleNames.includes(MANAGER) || userRoleNames.includes(ADMIN))
}

const _isEngineer = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && (userRoleNames.includes(ENGINEER))
}

const _isAdmin = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && userRoleNames.includes(ADMIN)
}

const _isStaff = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && userRoleNames.includes(STAFF)
}

const _isOnlyStaff = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames.join() === STAFF
}

const _isAdminOrStaff = (currentUser) => {
  return _isAdmin(currentUser) || _isStaff(currentUser)
}

// Could be a separate role?
const _isTrainer = (currentUser) => {
  return _isAdmin(currentUser) || _isStaff(currentUser)
}

const _isTrainee = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && userRoleNames.includes(TRAINEE)
}

const _isInterviewee = (currentUser) => {
  if(!currentUser) {return false}
  const userRoleNames = currentUser.roles;
  return userRoleNames && userRoleNames.includes(INTERVIEWEE)
}

const _findUserMainRole = (currentUser) => {
  if(_isManager(currentUser)) {
    return MANAGER
  }else if(_isStaff(currentUser)) {
    return STAFF
  }else if(_isAdmin(currentUser)){
    return ADMIN
  }else if(_isInterviewee(currentUser)) {
    return INTERVIEWEE
  }else if(_isTrainee(currentUser)) {
    return TRAINEE
  }else if(_isEngineer(currentUser)) {
    return ENGINEER
  }
}

const _findUserDashboardPath = (currentUser) => {
  let userRole = _findUserMainRole(currentUser)

  switch(userRole) {
    case MANAGER:
      return `/manager`
    case ADMIN:
    case STAFF:
      return `/staff/${currentUser.id}/reports`
    case ENGINEER:
      return '/manager/statuses'
    default:
      return '/not_found'
  }
}

export {
  _findUserDashboardPath,
  _isStaff,
  _isOnlyStaff,
  _isAdmin,
  _isTrainee,
  _isTrainer,
  _isAdminOrStaff,
  _isInterviewee,
  _findUserMainRole
}



// WEBPACK FOOTER //
// ./src/shared/javascripts/helpers/userRoles.js